var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRami06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FCBC00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.2,46.5c3.4,0,6.9,2.3,6.9,6.6c0,2.7-1.4,4.7-3.3,5.7c2.1,2.5,4,5.5,5.9,9.8h-5.4c-1.2-2.7-3.6-6.5-5.4-8.7 h-1.5v8.7h-5V46.5H22.2z M24.2,53.2c0-1.5-1.2-2.5-2.7-2.5h-2v4.9h1.9C23,55.7,24.2,54.9,24.2,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,69.1c-2.6,0-5-2-5-5.2c0-2.8,2.2-4.8,5.2-5.1l3-0.3v-0.6c0-0.9-0.8-1.6-2.4-1.6c-1.5,0-3.1,0.5-4.2,1.2 l-0.8-3.9c1.2-0.9,3.3-1.4,5.3-1.4c4,0,6.9,1.9,6.9,5.7V63c0,1.8,0.7,2.8,1.8,3.2l5.5,2.2c-1.7,2.6-9,3.7-11.2-1.4 C37.8,68.5,36.3,69.1,34.5,69.1z M37.6,61.7l-1.8,0.2c-1.2,0.1-1.8,1-1.8,2c0,0.9,0.6,1.5,1.5,1.5c1.1,0,2.2-0.9,2.2-2.3L37.6,61.7 L37.6,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.3,52.8v2.1l0,0c0.6-1.7,2.1-2.7,4.4-2.7c2.2,0,3.8,0.9,4.4,2.6c0.7-1.5,2.4-2.6,4.7-2.6 c3.4,0,5.4,2,5.4,5.3v11h-4.9v-9.6c0-1.1-0.6-2.2-2.2-2.2s-2.3,0.9-2.3,2.2v9.6H54v-9.6c0-1.1-0.6-2.2-2.2-2.2 c-1.6,0-2.3,0.9-2.3,2.2v9.6h-4.9V52.8H49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.9,45.2c1.4,0,2.6,1.2,2.6,2.7s-1.2,2.7-2.6,2.7c-1.4,0-2.6-1.2-2.6-2.7C69.2,46.5,70.4,45.2,71.9,45.2z  M74.3,52.8v15.7h-4.9V52.8H74.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.2,14.2c0.6,0.3,0.7,0.7,0.7,1.3c0,1.2,0,2.4,0,3.6c0,0.7-0.7,1.2-1.3,0.9c-0.4-0.2-0.6-0.5-0.6-0.9 c0-1.3,0-2.7,0-4c0-0.5,0.3-0.7,0.7-0.9C47.9,14.2,48,14.2,48.2,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.5,30.4c0.3-0.6,0.7-0.7,1.3-0.7c1.2,0,2.4,0,3.6,0c0.7,0,1.2,0.7,0.9,1.3c-0.2,0.4-0.4,0.6-0.9,0.6 c-1.3,0-2.7,0-4,0c-0.5,0-0.7-0.3-0.9-0.7C31.5,30.8,31.5,30.6,31.5,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.9,41.4c-1.2,0-2.4,0-3.7,0c-0.8,0-1.1-0.4-1.1-1.1c0-1.4-0.5-2.6-1.5-3.6c-4.4-4.6-2.5-12.3,3.6-14.3 c4.2-1.3,8.6,0.5,10.5,4.5c1.5,3.1,1,7-1.4,9.6c-0.7,0.8-1.3,1.6-1.5,2.7c-0.1,0.3-0.1,0.7-0.1,1.1c0,0.8-0.4,1.1-1.2,1.1 C50.4,41.4,49.2,41.4,47.9,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.8,25.8c-2,0-3.8,1.4-4.4,3.4c-0.2,0.6,0,1.2,0.6,1.3c0.5,0.2,1-0.1,1.2-0.7c0.4-1.3,1.4-2,2.7-2.1 c0.6,0,1-0.4,1-1C48.9,26.2,48.5,25.8,47.8,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.1,43.3c2.6,0,5.1,0,7.7,0c0.2,1.6-0.2,2.9-1.6,3.6c-0.3,0.2-0.7,0.3-1.1,0.3c-0.7,0-1.5,0.1-2.2,0 c-1.5-0.1-2.6-1.2-2.7-2.7C44.1,44.1,44.1,43.7,44.1,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.5,31.6c-0.6,0-1.2,0-1.8,0c-0.6,0-1.1-0.4-1.1-1c0-0.6,0.4-1,1.1-1c1.2,0,2.5,0,3.7,0c0.6,0,1.1,0.4,1.1,1 c0,0.6-0.4,1-1.1,1C62.7,31.6,62.1,31.6,61.5,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.2,18.8c0.1,0.1,0.4,0.1,0.6,0.3c0.9,0.9,1.8,1.8,2.7,2.7c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-1,0.4-1.4,0 c-0.9-0.9-1.8-1.8-2.7-2.7c-0.3-0.3-0.4-0.7-0.2-1.1C36.3,19,36.7,18.8,37.2,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.8,19.9c-0.1,0.1-0.2,0.4-0.3,0.6c-0.9,0.9-1.8,1.8-2.7,2.7c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4 c0.9-0.9,1.8-1.8,2.7-2.7c0.3-0.3,0.7-0.4,1.1-0.2C59.6,19,59.8,19.3,59.8,19.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRami06);
export default __webpack_public_path__ + "static/media/rami-06.f3644e2df106b18525223a5552fb586d.svg";
export { ForwardRef as ReactComponent };